import React from 'react';
import {handleResponse} from '../ext/common/rest-api-helper';
import * as R from 'ramda';

export type APIError = Error & {
  '@@type': 'Error',
  isDBPaused?: boolean
}

// TODO: Improve UnsafeApiResponse type. It doesn't work so well in later versions of TypeScript.
export type UnsafeAPIResponse<T> = T|APIError|undefined;

// TODO: useApi tests
/**
 * @summary Custom hook that gets a response by invoking a secure API endpoint.
 * @description Query a secure API endpoint. It authenticates with the user's ID token
 *              and handles JSON responses in the format { data?: any, error?: Error }.
 *              If an error occurs the result will contain a sanctuary type property
 *              of 'Error'. The result will be 'undefined' until a response is received
 *              from the API.
 */
export default function useApi<T>(apiToken: string, endpoint: string): UnsafeAPIResponse<T> {
  const [response, setResponse] = React.useState(undefined as UnsafeAPIResponse<T>);

  // eslint-disable-next-line
  React.useEffect(() => {
    if (apiToken) {
      fetch(endpoint, {
        headers: {Authorization: apiToken}
      }).then(handleResponse as (_: Response) => Promise<T>)
        .then(setResponse)
        .catch((err: Error) =>
          setResponse(R.merge(err, {'@@type': 'Error'}) as APIError));
    } else {
      setResponse(undefined);
    }
  }, [apiToken]);

  return response;
}
